import axios from "axios";
import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";
import { FaUndo, FaMoneyCheckAlt, FaGlasses } from "react-icons/fa";
import { FiSearch } from "react-icons/fi";
import { IoExitOutline } from "react-icons/io5";
import { API_HOST } from "../../api_utils";
import { Box, Divider, Modal } from "@mui/material";
import { GrDocumentMissing } from "react-icons/gr";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

function TransactionReport(props) {
  const { userDataFromStorage, coloredTheme } = props;
  const [userList, setUserList] = useState([]);
  const [loanHeaderList, setLoanHeaderList] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [transactionList, setTransactionList] = useState([]);
  const [cashReconciliationList, setCashReconciliationList] = useState([]);
  const [claimList, setClaimList] = useState([]);
  const [transReport, setTransReport] = useState([]);

  const [isCashLoanedReview, setIsCashLoanedReview] = useState(false);
  const [isCashPlusReview, setIsCashPlusReview] = useState(false);
  const [isClaimsReview, setIsClaimsReview] = useState(false);

  const [currentCashLoan, setCurrentCashLoan] = useState({});
  const [currentCashPlus, setCurrentCashPlus] = useState({});
  const [currentClaim, setCurrentClaim] = useState({});

  // states for filter:
  const [currentData, setCurrentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [managerName, setManagerName] = useState("");
  const [agentName, setAgentName] = useState("");

  const singaporeTimezone = "Asia/Singapore";
  const currentDateInSingapore = new Date().toLocaleDateString("en-US", {
    timeZone: singaporeTimezone,
  });
  const [reportDate, setReportDate] = useState(
    formatDate(currentDateInSingapore)
  );

  function formatDate(dateString) {
    const [month, day, year] = dateString.split("/");
    const formattedMonth = month.padStart(2, "0");
    const formattedDay = day.padStart(2, "0");
    return `${year}-${formattedMonth}-${formattedDay}`;
  }

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [cashCollectModel, setCashCollectModel] = useState(false);
  const [cashLoanedModel, setCashLoanedModel] = useState(false);
  const [claimsReviewModel, setClaimsReviewModel] = useState(false);
  const [cashLoanModelData, setCashLoanModelData] = useState({});
  const [claimModelData, setClaimModelData] = useState({});
  const [cashCollectedModelData, setCashCollectedModelData] = useState({});
  const [currentData1, setCurrentData1] = useState([]);
  const [currentData2, setCurrentData2] = useState([]);
  const [currentData3, setCurrentData3] = useState([]);
  const [overAllData, setOverAllData] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [totalCashLoaned, setTotalCashLoaned] = useState(0);
  const [totalCashCollected, setTotalCashCollected] = useState(0);
  const [totalCashClaimed, setTotalCashClaimed] = useState(0);
  const [detailLoanSuccess, setDetailLoanSuccess] = useState(false);

  const [agentNameList, setAgentNameList] = useState([]);

  const [agentNameForApi, setAgentNameForApi] = useState("");
  const [selectedAgentName, setSelectedAgentName] = useState("");

  const searchFilterOptionsShow = useRef(true);
  const [overallPaginatedData, setOverallPaginatedData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  function compareNicknames(a, b) {
    const nicknameA = (a.manager_name || "").toUpperCase();
    const nicknameB = (b.manager_name || "").toUpperCase();

    if (nicknameA < nicknameB) {
      return -1;
    }
    if (nicknameA > nicknameB) {
      return 1;
    }
    return 0;
  }

  function compareNicknames1(a, b) {
    const nicknameA = (a.agent_name || "").toUpperCase();
    const nicknameB = (b.agent_name || "").toUpperCase();

    if (nicknameA < nicknameB) {
      return -1;
    }
    if (nicknameA > nicknameB) {
      return 1;
    }
    return 0;
  }

  // CASH LOANED
  const getTransActionReport = async () => {
    const { userDataFromStorage } = props;

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/transactions/get_transaction_report?page=${currentPage}&pageSize=${pageSize}`;

    const queryParams = [];

    if (managerName) {
      queryParams.push(`manager_name=${managerName}`);
    }

    if (agentNameForApi) {
      queryParams.push(`agent_name=${agentNameForApi}`);
    }

    if (reportDate) {
      queryParams.push(`report_date=${reportDate}`);
    }

    if (queryParams.length > 0) {
      const queryString = queryParams.join("&");
      apiUrl += `&${queryString}`;
    }
    setLoading(true);

    const { data } = await axios.get(apiUrl, config);
    if (data) {
      if (!data.message) {
        setLoading(false);
        setCurrentData(data);
      }
    }
  };

  // CASH PLUS
  const getTransActionReport1 = async () => {
    const { userDataFromStorage } = props;

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/transactions/get_transaction_report_1?page=${currentPage}&pageSize=${pageSize}`;

    const queryParams = [];

    if (reportDate) {
      queryParams.push(`report_date=${reportDate}`);
    }

    if (managerName) {
      queryParams.push(`manager_name=${managerName}`);
    }

    if (agentNameForApi) {
      queryParams.push(`agent_name=${agentNameForApi}`);
    }

    if (queryParams.length > 0) {
      const queryString = queryParams.join("&");
      apiUrl += `&${queryString}`;
    }
    setLoading(true);

    const { data } = await axios.get(apiUrl, config);
    if (data) {
      if (!data.message) {
        setLoading(false);
        setCurrentData1(data);
      }
    }
  };

  // CASH COLLECTED
  const getTransActionReport2 = async () => {
    const { userDataFromStorage } = props;

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/transactions/get_transaction_report_2?page=${currentPage}&pageSize=${pageSize}`;

    const queryParams = [];

    if (reportDate) {
      queryParams.push(`report_date=${reportDate}`);
    }

    if (managerName) {
      queryParams.push(`manager_name=${managerName}`);
    }

    if (agentNameForApi) {
      queryParams.push(`agent_name=${agentNameForApi}`);
    }

    if (queryParams.length > 0) {
      const queryString = queryParams.join("&");
      apiUrl += `&${queryString}`;
    }
    setLoading(true);

    const { data } = await axios.get(apiUrl, config);
    if (data) {
      if (!data.message) {
        setLoading(false);
        setCurrentData2(data);
      }
    }
  };

  // CLAIMS
  const getTransActionReport3 = async () => {
    const { userDataFromStorage } = props;

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/transactions/get_transaction_report_3?page=${currentPage}&pageSize=${pageSize}`;

    const queryParams = [];

    if (reportDate) {
      queryParams.push(`report_date=${reportDate}`);
    }

    if (managerName) {
      queryParams.push(`manager_name=${managerName}`);
    }

    if (agentNameForApi) {
      queryParams.push(`agent_name=${agentNameForApi}`);
    }

    if (queryParams.length > 0) {
      const queryString = queryParams.join("&");
      apiUrl += `&${queryString}`;
    }
    setLoading(true);

    const { data } = await axios.get(apiUrl, config);
    if (data) {
      if (!data.message) {
        setLoading(false);
        setCurrentData3(data);
      }
    }
  };

  const cashCollectedDataHandler = async (agent) => {
    console.log("here123:::::::::");
    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    const payload = {
      id_number: agent,
      report_date: reportDate,
    };

    let apiUrl = `${API_HOST}/api/transactions/cash_collected_detail`;

    const { data } = await axios.post(apiUrl, payload, config);

    if (data) {
      if (!data.message) {
        if (!data.message) {
          setLoading(false);

          setCashCollectedModelData(data);

          if (data.length > 0) {
            let sum = 0;
            data.map((x) => {
              return (sum += x.transaction_amount);
            });
            setTotalCashCollected(sum);
          }
        } else {
          setLoading(false);
          setCashCollectedModelData([]);
        }
      }
    }
  };

  const cashLoanedDataHandler = async (agent) => {
    console.log("here123:::::::::");
    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    const payload = {
      id_number: agent,
      report_date: reportDate,
    };

    let apiUrl = `${API_HOST}/api/transactions/cash_loaned_detail`;

    const { data } = await axios.post(apiUrl, payload, config);
    console.log("data here ::::::::", data);
    if (data) {
      if (!data.message) {
        setLoading(false);
        console.log("data111::::::", data);
        let sortedData = data.sort((a, b) => a.loan_number - b.loan_number);
        setCashLoanModelData(sortedData);

        if (data.length > 0) {
          let sum = 0;
          data.map((x) => {
            return (sum += x.cash_loaned);
          });
          setTotalCashLoaned(sum);
        }
      } else {
        setLoading(false);
        setCashLoanModelData([]);
      }
    }
  };

  const claimDataHandler = async (agent) => {
    console.log("here123:::::::::");
    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };
    const payload = {
      id_number: agent,
      report_date: reportDate,
    };

    let apiUrl = `${API_HOST}/api/transactions/claim_detail`;

    const { data } = await axios.post(apiUrl, payload, config);
    console.log("data here ::::::::", data);
    if (data) {
      if (!data.message) {
        setLoading(false);

        setClaimModelData(data);

        if (data.length > 0) {
          let sum = 0;
          data.map((x) => {
            return (sum += x.amount);
          });
          setTotalCashClaimed(sum);
        }
      } else {
        setLoading(false);
        setClaimModelData([]);
      }
    }
  };

  const managerRelatedUserFetch = async (agent) => {
    console.log("here123:::::::::");
    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/users/transaction_user_relation`;

    const { data } = await axios.get(apiUrl, config);
    console.log("data here ::::::::", data);
    if (data) {
      if (!data.message) {
        setLoading(false);
        console.log("data::::::", data);
        // setCashLoanModelData(data);
        setAllUsers(data);
      }
    }
  };

  const getAllAgentNames = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage?.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/users/agent_name_list`;

    const { data } = await axios.get(apiUrl, config);
    if (!data.message) {
      setLoading(false);
      setAgentNameList(data);
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTransActionReport();
    getTransActionReport1();
    getTransActionReport2();
    getTransActionReport3();
    getAllAgentNames();

    cashCollectedDataHandler();
    claimDataHandler();
    managerRelatedUserFetch();
  }, [reportDate, agentNameForApi]);

  useEffect(() => {
    if (allUsers.length) {
      async function fetchData() {
        let combinedArray = [];
        if (agentNameForApi) {
          let userDetail = allUsers.filter(
            (x) => x.last_name === agentNameForApi
          );
          combinedArray = await Promise.all(
            userDetail.map(async (item1) => {
              console.log("item1:::", item1);
              const matchingItem1 =
                currentData.find(
                  (item2) => item2._id === item1.employee_number
                ) || {};
              const matchingItem2 =
                currentData1.find(
                  (item3) => item3._id === item1.employee_number
                ) || {};
              const matchingItem3 =
                currentData2.find(
                  (item4) => item4._id === item1.employee_number
                ) || {};
              const matchingItem4 =
                currentData3.find(
                  (item4) => item4._id === item1.employee_number
                ) || {};

              return {
                _id: item1.employee_number,
                cash_loaned: matchingItem1.cash_loaned || 0,
                cash_collected: matchingItem3.cash_collected || 0,
                cash_plus:
                  matchingItem2.cash_plus === 0
                    ? 0
                    : matchingItem2.cash_plus !== undefined
                    ? matchingItem2.cash_plus
                    : "No Entry !!!",
                claims: matchingItem4.claims || 0,
                agent_name: item1.agent_name || item1.last_name,
                manager_name: item1.managerName ? item1.managerName : "",
              };
            })
          );
        } else {
          combinedArray = await Promise.all(
            allUsers.map(async (item1) => {
              console.log("item1:::", item1);
              const matchingItem1 =
                currentData.find(
                  (item2) => item2._id === item1.employee_number
                ) || {};
              const matchingItem2 =
                currentData1.find(
                  (item3) => item3._id === item1.employee_number
                ) || {};
              const matchingItem3 =
                currentData2.find(
                  (item4) => item4._id === item1.employee_number
                ) || {};
              const matchingItem4 =
                currentData3.find(
                  (item4) => item4._id === item1.employee_number
                ) || {};

              return {
                _id: item1.employee_number,
                cash_loaned: matchingItem1.cash_loaned || 0,
                cash_collected: matchingItem3.cash_collected || 0,
                cash_plus:
                  matchingItem2.cash_plus === 0
                    ? 0
                    : matchingItem2.cash_plus !== undefined
                    ? matchingItem2.cash_plus
                    : "No Entry !!!",
                claims: matchingItem4.claims || 0,
                agent_name: item1.agent_name || item1.last_name,
                manager_name: item1.managerName ? item1.managerName : "",
              };
            })
          );
        }

        let combinedArrayNew = combinedArray.sort(function (a, b) {
          if (userDataFromStorage.user_role === "admin") {
            let currentUser = userDataFromStorage.login_name;
            let nameA = a.manager_name;
            let nameB = b.manager_name;
            if (nameA === currentUser) {
              return -1; // Current user comes before other users
            }
            if (nameB === currentUser) {
              return 1; // Other user comes before current user
            }
            // If neither name is the current user, compare them alphabetically
            return nameA.localeCompare(nameB);
          } else if (userDataFromStorage.user_role === "manager") {
            let nameA = a.agent_name.toUpperCase(); // Convert names to uppercase for case-insensitive comparison
            let nameB = b.agent_name.toUpperCase();
            if (nameA < nameB) {
              return -1; // A comes before B
            }
            if (nameA > nameB) {
              return 1; // A comes after B
            }
            return 0; // Names are equal
          }
        });

        setOverAllData(combinedArrayNew);
      }

      fetchData();
    }
  }, [
    currentData,
    currentData1,
    currentData2,
    currentData3,
    allUsers,
    agentNameForApi,
  ]);

  const options = { day: "2-digit", month: "2-digit", year: "numeric" };

  const handleAgentNameChange = useCallback((e) => {
    setAgentName(e.target.value);
  }, []);

  const filteredAgentOptions = useMemo(() => {
    if (agentName && !selectedAgentName) {
      console.log("here");
      const searchTerm = agentName.toLowerCase();
      const optionsStartingWithSearchTerm = [];

      console.log("searchTerm", searchTerm);

      agentNameList.forEach((option) => {
        if (
          option.agent_name &&
          option.agent_name.toLowerCase().startsWith(searchTerm)
        ) {
          console.log(
            "option.agent_name.toLowerCase().startsWith(searchTerm)",
            option.agent_name.toLowerCase().startsWith(searchTerm)
          );
          optionsStartingWithSearchTerm.push(option);
        }
      });

      optionsStartingWithSearchTerm.sort((a, b) =>
        a.agent_name.localeCompare(b.agent_name, undefined, {
          sensitivity: "base",
        })
      );

      console.log(
        "optionsStartingWithSearchTerm",
        optionsStartingWithSearchTerm
      );

      // setAgentLastName("");

      return optionsStartingWithSearchTerm;
    } else {
      console.log("here agent");
      if (selectedAgentName) {
        console.log("here agent1111");
        setAgentNameForApi(selectedAgentName);
        setSelectedAgentName("");

        searchFilterOptionsShow.current = false;
      } else {
        console.log("here agent222");
        searchFilterOptionsShow.current = true;
      }

      return [];
    }
  }, [agentName, selectedAgentName]);

  useEffect(() => {
    if (overAllData.length) {
      setTotalPages(Math.ceil(overAllData.length / 20));

      // Calculate the index range for the current page
      const startIndex = (page - 1) * 20;
      const endIndex = startIndex + 20;

      // Slice the data array based on the current page
      const currentDataNew = overAllData.slice(startIndex, endIndex);
      setOverallPaginatedData(currentDataNew);
    }
  }, [overAllData, page]);

  return (
    <div
      className={
        userDataFromStorage.user_role === "admin"
          ? "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-blue-50  overflow-hidden"
          : "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[5%] mt-[20%] bg-blue-50 overflow-hidden"
      }>
      <p className="text-gray-800 text-[1.8rem] tracking-wider">
        Transaction Report
      </p>

      <div className="bg-white  mt-[2%]">
        <p
          style={{ backgroundColor: coloredTheme }}
          className=" text-white px-[0.5rem] py-[1rem] ">
          Search Parameters
        </p>

        <div className="px-[0.5rem] mt-2">
          {userDataFromStorage.user_role === "admin" && (
            <div className="md:flex justify-start items-center mt-6">
              <p className="w-[25rem]">Manager Last Name</p>
              <input
                value={managerName}
                onChange={(e) => setManagerName(e.target.value)}
                type="text"
                className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
              />
            </div>
          )}
          <div className="relative md:flex justify-start items-center mt-6">
            <p className="w-[30%]">Agent Last Name</p>
            <input
              type="text"
              value={agentName}
              placeholder="Enter Agent Last Name"
              onInput={(e) => {
                console.log("e.target::::::", e.target.value);
                handleAgentNameChange(e);
              }}
              className="outline-none  border border-gray-300 rounded-lg  w-[70%]   p-[0.8rem] "
            />
            {filteredAgentOptions.length > 0 && (
              <div
                className={
                  searchFilterOptionsShow.current === true
                    ? "absolute 2xl:top-[4rem] lg:top-[4rem] lg:max-h-[12rem] xl:top-[4rem] xl:max-h-[12rem] 2xl:max-h-[13rem] overflow-y-scroll w-[100%]  rounded-lg shadow-xl bg-white z-10"
                    : "hidden"
                }>
                {filteredAgentOptions.map((option, index) => (
                  <div
                    className="bg-white cursor-pointer p-[0.5rem] hover:bg-cyan-200 transition duration-[0.3s]"
                    onClick={() => {
                      console.log("option.agent_name::", option.agent_name);
                      setAgentName(option.agent_name);
                      setSelectedAgentName(option.agent_name);
                    }}
                    key={index}>
                    {option.agent_name}
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="md:flex justify-start items-center mt-6">
            <p className="w-[25rem]">Report Date</p>
            <input
              value={reportDate}
              onChange={(e) => setReportDate(e.target.value)}
              type="date"
              className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
            />
          </div>
        </div>

        <div className="flex justify-start items-center space-x-4 p-[1rem]">
          <button
            onClick={() => getTransActionReport()}
            style={{ backgroundColor: coloredTheme }}
            className="flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white">
            <FiSearch />
            <p>Search</p>
          </button>
          <button
            onClick={() => {
              setAgentName("");
              setManagerName("");
              setReportDate("");
            }}
            style={{ backgroundColor: coloredTheme }}
            className="flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white">
            <FaUndo />
            <p>Reset</p>
          </button>
        </div>
      </div>

      <div className="mt-8 ">
        <p
          style={{ backgroundColor: coloredTheme }}
          className=" p-[1rem] text-white">
          Report
        </p>
        <div className="overflow-scroll ">
          {loading ? (
            <div className="flex justify-center items-center py-[3rem]">
              <div
                class="w-20 h-20 rounded-full animate-spin
            border-2 border-solid border-blue-500 border-t-transparent"></div>
            </div>
          ) : (
            <>
              <table className="xl:w-[100%] lg:w-[130%] md:w-[170%] w-[300%]">
                <thead className="h-[6vh]">
                  <tr>
                    {userDataFromStorage.user_role === "admin" ? (
                      <th className="text-center">Manager</th>
                    ) : (
                      ""
                    )}
                    <th className="text-center">Agent</th>
                    <th className="text-center">Cash Loaned</th>
                    <th className="text-center">Cash Collected</th>
                    <th className="text-center">Claims</th>
                    <th className="text-center">Cash +/-</th>
                    <th className="text-center">Review</th>
                    <th className="text-center">Review</th>
                    <th className="text-center">Review</th>
                  </tr>
                </thead>
                <tbody>
                  {overallPaginatedData.length
                    ? overallPaginatedData.map((x) => (
                        <tr
                          key={x._id}
                          className="bg-white border border-gray-600">
                          {userDataFromStorage.user_role === "admin" ? (
                            <td className="border-r border-gray-600 text-center">
                              {x.manager_name}
                            </td>
                          ) : (
                            ""
                          )}
                          <td className="border-r border-gray-600 text-center">
                            {x.agent_name}
                          </td>
                          <td className="border-r border-gray-600 text-center">
                            MYR {x.cash_loaned ? x.cash_loaned : 0}
                          </td>
                          <td className="border-r border-gray-600 text-center">
                            MYR {x.cash_collected ? x.cash_collected : 0}
                          </td>
                          <td className="border-r border-gray-600 text-center">
                            MYR {x.claims ? x.claims : 0}
                          </td>
                          <td className="text-center border-r border-gray-600">
                            {x.cash_plus === "No Entry !!!" ? (
                              <p>{x.cash_plus}</p>
                            ) : (
                              `MYR ${x.cash_plus ? x.cash_plus : 0}`
                            )}
                          </td>
                          <td className="py-[1rem] border-r border-gray-600 justify-center  items-center ">
                            <button
                              onClick={() => {
                                console.log("x loan::::::", x);
                                setCashLoanedModel(true);
                                cashLoanedDataHandler(x._id);
                              }}
                              style={{ backgroundColor: coloredTheme }}
                              className="text-white text-center rounded px-[1rem] py-[0.5rem] ">
                              Cash Loaned
                            </button>
                          </td>
                          <td className="py-[1rem] border-r  border-gray-600  justify-center  items-center">
                            <button
                              onClick={() => {
                                console.log("x collected::::::", x);
                                setCashCollectModel(true);
                                cashCollectedDataHandler(x._id);
                              }}
                              style={{ backgroundColor: coloredTheme }}
                              className="text-white text-center rounded px-[1rem] py-[0.5rem] mx-auto">
                              Cash Collected
                            </button>
                          </td>
                          <td className="py-[1rem] justify-center  items-center">
                            <button
                              onClick={() => {
                                console.log("x collected::::::", x);
                                setClaimsReviewModel(true);
                                claimDataHandler(x._id);
                              }}
                              style={{ backgroundColor: coloredTheme }}
                              className="text-white text-center rounded px-[1rem] py-[0.5rem] mx-auto">
                              Review Claims
                            </button>
                          </td>
                        </tr>
                      ))
                    : ""}
                </tbody>
              </table>
              <div className=" flex justify-end items-center mt-[2%] px-[0.8rem]">
                <Stack spacing={2}>
                  <Pagination
                    count={totalPages}
                    page={page}
                    onChange={(event, newPage) => setPage(newPage)}
                    variant="outlined"
                    shape="rounded"
                  />
                </Stack>
              </div>
            </>
          )}
        </div>

        <div className="mt-6 ">
          <button
            style={{ backgroundColor: coloredTheme }}
            className="flex justify-center items-center rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white">
            <IoExitOutline />
            <p>Exit</p>
          </button>
        </div>
      </div>

      {/* CASH LOANED MODAL */}
      <Modal
        open={cashLoanedModel}
        onClose={() => {
          setTotalCashLoaned(0);
          setCashLoanedModel(false);
        }}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem] ">
        <Box className="md:w-[80%] w-[95%]  rounded-lg bg-sky-50 absolute top-[8%] mb-[10rem] ">
          <div className="p-[2rem]">
            <p className="text-lg text-gray-800 text-[1.5rem] font-[400] font-Roboto">
              Cash Loaned Out Review
            </p>
            <Divider />
            <p className="mt-3 text-[0.9rem] tracking-wider ">
              Total Cash Loaned Out on {reportDate} is MYR
              <strong> {totalCashLoaned}</strong>
            </p>
            <div className="mt-[1.5rem] w-[100%] overflow-x-scroll">
              {cashLoanModelData.length ? (
                <table className="xl:w-[100%] lg:w-[130%] md:w-[170%] w-[200%] ">
                  <thead className="h-[6vh]">
                    <tr className="text-gray-600 h-[1.5rem]">
                      <th className="text-center">Customer Nickname</th>
                      <th className="text-center">Loan Number</th>
                      <th className="text-center">Cash Loaned Out</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cashLoanModelData.length &&
                      cashLoanModelData.map((x, index) => (
                        <tr
                          key={index}
                          className=" h-[1.5rem] border bg-white border-t border-b border-gray-500">
                          <td className=" text-center border-r border-gray-500">
                            {x.nickname}
                          </td>
                          <td className="text-center border-r border-gray-500">
                            {x.loan_number}
                          </td>
                          <td className=" text-center">MYR {x.cash_loaned}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              ) : (
                <div className="h-[8rem] w-[100%] flex justify-center items-center">
                  <div className="flex justify-center items-center space-x-[1.5rem] w-[100%]">
                    <GrDocumentMissing className="text-[5rem]" />
                    <p className="text-[1.5rem] tracking-wider font-Roboto font-[500]">
                      No Cash Loan Data is Available for {reportDate}{" "}
                    </p>
                  </div>
                </div>
              )}

              <div className="flex justify-start items-start mt-8">
                <button
                  onClick={() => {
                    setCashLoanedModel(false);
                    setTotalCashLoaned(0);
                  }}
                  className="tracking-wider text-white bg-green-400 rounded-lg px-6 py-2">
                  Return
                </button>
              </div>
            </div>
          </div>
        </Box>
      </Modal>

      {/* CLAIMS MODEL */}
      <Modal
        open={claimsReviewModel}
        onClose={() => {
          setClaimsReviewModel(false);
          setTotalCashClaimed(0);
        }}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem] ">
        <Box className="md:w-[80%] w-[95%]  rounded-lg bg-sky-50 absolute top-[8%] mb-[10rem] ">
          <div className="p-[2rem]">
            <p className="text-lg text-gray-800 text-[1.5rem] font-[400] font-Roboto">
              Claims Review
            </p>
            <Divider />
            <p className="mt-3 text-[0.9rem] tracking-wider ">
              Total Claims Made on {reportDate} are MYR{" "}
              <strong> {totalCashClaimed}</strong>
            </p>
            <div className="mt-[1.5rem] w-[100%] overflow-x-scroll">
              {claimModelData.length ? (
                <table className="xl:w-[100%] lg:w-[130%] md:w-[170%] w-[200%] ">
                  <thead className="h-[6vh]">
                    <tr className="text-gray-600 h-[1.5rem]">
                      <th className="text-center">Claimer Ref</th>
                      <th className="text-center">Claim No</th>
                      <th className="text-center">Claim Type</th>
                      <th className="text-center">Other Type</th>
                      <th className="text-center">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {claimModelData.length &&
                      claimModelData.map((x, index) => (
                        <tr
                          key={index}
                          className=" h-[1.5rem] border border-t-1 border-gray-500 bg-white">
                          <td className=" text-center border-r border-gray-500">
                            {x.claimer_ref}
                          </td>
                          <td className="text-center border-r border-gray-500">
                            {x.claim_number}
                          </td>
                          <td className=" text-center border-r border-gray-500">
                            {" "}
                            {x.claim_type}
                          </td>
                          <td className=" text-center border-r border-gray-500">
                            {" "}
                            {x.claim_reason ? x.claim_reason : "N/A"}
                          </td>
                          <td className=" text-center">MYR {x.amount}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              ) : (
                <div className="h-[8rem] w-[100%] flex justify-center items-center">
                  <div className="flex justify-center items-center space-x-[1.5rem] w-[100%]">
                    <GrDocumentMissing className="text-[5rem]" />
                    <p className="text-[1.5rem] tracking-wider font-Roboto font-[500]">
                      No Claim Data is Available for {reportDate}{" "}
                    </p>
                  </div>
                </div>
              )}

              <div className="flex justify-start items-start mt-8">
                <button
                  onClick={() => {
                    setClaimsReviewModel(false);
                    setTotalCashClaimed(0);
                  }}
                  className="tracking-wider text-white bg-green-400 rounded-lg px-6 py-2">
                  Return
                </button>
              </div>
            </div>
          </div>
        </Box>
      </Modal>

      {/* CASH COLLECTED MODEL */}
      <Modal
        open={cashCollectModel}
        onClose={() => {
          setCashCollectModel(false);
          setTotalCashCollected(0);
        }}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem] ">
        <Box className="md:w-[80%] w-[95%]  rounded-lg bg-sky-50 absolute top-[8%] mb-[10rem] ">
          <div className="p-[2rem]">
            <p className="text-lg text-gray-800 text-[1.5rem] font-[400] font-Roboto">
              Cash Collected Review
            </p>
            <Divider />
            <p className="mt-3 text-[0.9rem] tracking-wider ">
              Total Cash Collected on {reportDate} is MYR{" "}
              <strong>{totalCashCollected}</strong>
            </p>
            <div className="mt-[1.5rem] w-[100%] overflow-x-scroll">
              {cashCollectedModelData.length ? (
                <table className="xl:w-[100%] lg:w-[130%] md:w-[170%] w-[200%] ">
                  <thead className="h-[6vh]">
                    <tr className="text-gray-600 h-[1.5rem]">
                      <th className="text-center">Customr nickname</th>
                      <th className="text-center">Loan Number</th>
                      <th className="text-center">Agent</th>
                      <th className="text-center">Transaction Entered By</th>
                      <th className="text-center">Transaction Number</th>
                      <th className="text-center">Transaction Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cashCollectedModelData.length &&
                      cashCollectedModelData.map((x, index) => (
                        <tr
                          key={index}
                          className=" h-[1.5rem] border border-gray-500 bg-white">
                          <td className=" text-center border-r border-gray-500">
                            {x.nickname}
                          </td>
                          <td className="text-center border-r border-gray-500">
                            {x.agent_loan}
                          </td>
                          <td className=" text-center border-r border-gray-500">
                            {x.agent_name}
                          </td>
                          <td className=" text-center border-r border-gray-500">
                            {" "}
                            {x.entered_by}
                          </td>
                          <td className=" text-center border-r border-gray-500">
                            {x.transaction_number}
                          </td>
                          <td className=" text-center">
                            MYR {x.transaction_amount}
                          </td>
                          {/* <td className=" text-center">MYR 0</td> */}
                        </tr>
                      ))}
                  </tbody>
                </table>
              ) : (
                <div className="h-[8rem] w-[100%] flex justify-center items-center">
                  <div className="flex justify-center items-center space-x-[1.5rem] w-[100%]">
                    <GrDocumentMissing className="text-[5rem]" />
                    <p className="text-[1.5rem] tracking-wider font-Roboto font-[500]">
                      No Cash Collection Data is Available for {reportDate}{" "}
                    </p>
                  </div>
                </div>
              )}

              <div className="flex justify-start items-start mt-8">
                <button
                  onClick={() => {
                    setCashCollectModel(false);
                    setTotalCashCollected(0);
                  }}
                  className="tracking-wider text-white bg-green-400 rounded-lg px-6 py-2">
                  Return
                </button>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default TransactionReport;
